<div class="pan-already-searched-dialog">
  <div class="dialog-content">
    <!-- Information Icon -->
    <div class="icon-container">
      <div class="info-icon">
        <span class="info-letter">i</span>
      </div>
    </div>

    <!-- Title -->
    <h2 class="dialog-title">PAN Already Searched</h2>

    <!-- Message -->
    <p class="dialog-message">
      This PAN was previously searched on {{ formattedDate }}
    </p>

    <!-- Action Buttons -->
    <div class="button-container">
      <button 
        class="btn view-report-btn" 
        (click)="onViewPreviousReport()"
        mat-button
      >
        <mat-icon>description</mat-icon>
        <span>View Previous Report</span>
      </button>

      <button 
        class="btn fresh-search-btn" 
        (click)="onFreshSearch()"
        mat-button
      >
        <mat-icon>refresh</mat-icon>
        <span>Fresh Search</span>
      </button>

      <button 
        class="btn cancel-btn" 
        (click)="onCancel()"
        mat-button
      >
        <span>Cancel</span>
      </button>
    </div>
  </div>
</div>

